import { useState } from "react";
import { ProductListModel } from "models/productListModel";
import { styled } from "styled-components";
import ProductListItemHorizontal from "./ProductListItemHorizontal";
import RectangleButton from "components/atoms/RectangleButton";
import BenefitSectionTitle from "./BenefitSectionTitle";
import { usePostCoupangViewLog } from "api/queries";
import { isAndroid } from "react-device-detect";
import { logEvent } from "firebase/analytics";
import { analytics } from "lib/firebase";

interface Props {
  productData: ProductListModel[];
  title?: string;
  subTitle?: string;
}

const PersonalProductList = ({ productData, title, subTitle }: Props) => {
  const [expanded, setExpanded] = useState(false);
  const categoryCd =
    (productData && productData.length > 0 && productData[0].categoryCd) || 0;
  const osType = isAndroid ? "1" : "2";
  const viewLogmutation = usePostCoupangViewLog();

  const toggleExpand = () => {
    if (!expanded) {
      logEvent(analytics, "Web_benefit_home_my_B");
    }
    setExpanded((prev) => !prev);
  };

  const visibleProducts = expanded ? productData : productData.slice(0, 4);

  const logCoupangView = ({
    productId,
    itemId,
    refTy,
    refId,
    url,
  }: {
    refTy: number;
    refId?: number;
    productId?: number;
    itemId?: number;
    url?: string;
  }) => {
    viewLogmutation.mutate({
      productId,
      itemId,
      categoryCd,
      osType,
      refTy,
      ...(refTy == 11 && { refId }),
      url,
    });
  };

  return (
    <>
      {title && <BenefitSectionTitle title={title} text={subTitle || ""} />}
      <StyledProductListHorizontal>
        {visibleProducts.map((product, index) => {
          return (
            <ProductListItemHorizontal
              key={`${product.productNm}` + index}
              productData={product}
              onClickProduct={() => {
                if (product.refTy) {
                  logCoupangView({
                    refTy: product.refTy,
                    refId: product.refId,
                    productId: product.productId,
                    itemId: product.itemId,
                    url: product.productUrl,
                  });
                }
              }}
            />
          );
        })}
      </StyledProductListHorizontal>
      {productData.length > 4 && (
        <StyledButtonBox>
          <RectangleButton
            onClick={toggleExpand}
            text={expanded ? "접기" : "내 맞춤 제품 더 보기"}
            width={"100%"}
          />
        </StyledButtonBox>
      )}
    </>
  );
};

export default PersonalProductList;

const StyledProductListHorizontal = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0px 20px;
`;

const StyledButtonBox = styled.div`
  margin-top: 24px;
  padding: 0px 20px;
`;
